import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Checkout from '../views/Checkout.vue'
import Exemplos from '../views/Exemplos.vue'
import Apresentacao from '../views/Apresentacao.vue'
import Produto from '../views/Produto'
import MercadoPago from '../views/MercadoPago.vue'

Vue.use(VueRouter)

const routes = [
	{ path: '/', name: 'Apresentacao', component: Apresentacao, },
	{ path: '/exemplos', component: Exemplos },
	{ path: '/mercadopago', component: MercadoPago },
	{ path: '/:catalogo/checkout', name: 'Checkout', component: Checkout, },
	{ path: '/:catalogo', component: Home, },
	{ path: '/:catalogo/:codigo/:descricao', component: Produto, name: "Produto" },
	{ path: '/:catalogo/:codigo/:descricao/:sku', component: Produto },
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
